<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <div class="card-header-title">
                            <span class="mdi mdi-home-city-outline text-muted mr-2"></span> 
                            Reports
                            <span v-if="isSearchResult"> - Results for '{{ searchTermWas }}'</span>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-6 col-md-6">
                        <div class="input-group input-group">
                            <input type="text" class="form-control" placeholder="Search by job number, address or surveyor" aria-label="Search Reports" v-model="searchTerm" @keydown.enter="searchReports">
                            <div class="input-group-append">
                                <button class="btn btn-success" type="button" @click="searchReports">
                                    <span class="mdi mdi-magnify"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body" v-if="reports && viewState == 'Idle'">
                <b-table ref="reportTable"
                    hover small striped borderless
                    :items="reports"
                    :fields="reportFields">
                    <template v-slot:cell(_address)="data">
                        {{ formatAddress(data.item.property) }}
                    </template>
                    <template v-slot:cell(_actions)="data">
                        <router-link class="btn btn-sm float-right mr-1"  :class="data.item.report_status == 'Active' ? 'btn-secondary' : 'btn-primary'"
                                     :to="{ name: routes.Reports.ReportEdit, params: { jobReference: data.item.job_reference } }">
                            {{ data.item.report_status == 'Pending' ? 'Start' : 'Edit' }} &raquo;
                        </router-link>
                    </template>
                </b-table>

                <div class="row mt-4">
                    <div class="col">
                        <div v-if="!isSearchResult">
                            Page <strong>{{ pageNumber }}</strong> of <strong>{{ totalPages }}</strong> |
                            <strong>{{ totalResults }}</strong> results
                        </div>
                        <div v-if="isSearchResult">
                            Showing <strong>{{ reports.length }}</strong> results for '{{ searchTermWas }}'
                        </div>
                    </div>
                    <div class="col">
                        <div class="float-right" v-if="!isSearchResult">
                            <button class="btn btn-success btn-sm mr-2" :disabled="pageNumber == 1" @click="previousPage">
                                &laquo; Previous
                            </button>
                            <button class="btn btn-success btn-sm" :disabled="pageNumber == totalPages" @click="nextPage">
                                Next &raquo;
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <LoadingIndicator v-if="viewState == 'Busy'" />
            <ErrorMessage v-if="viewState == 'Error'" />
        </div>
    </div>
</template>

<script>
    import ReportService from '../../services/reports/reportService'
    import { RouteNames } from '../../utils/constants'

    export default {
        props: {
            resultPageSize: {
                type: Number, 
                default: 20
            },
            resultPageNumber: {
                type: Number, 
                default: 1
            }
        },
        data() {
            return {
                viewState: 'Idle',
                error: null,
                routes: RouteNames,
                reports: null,
                pageNumber: null,
                totalPages: null,
                pageSize: null,
                totalResults: null,
                isSearchResult: false,
                searchSummary: null,
                searchTerm: null,
                searchTermWas: null,
                reportFields: [
                    { key: 'job_reference', label: 'Job Number' },
                    { key: 'report_type', label: 'Type' },
                    { key: '_address', label: 'Address' },
                    { key: 'surveyor.name', label: 'Surveyor' },
                    {
                        key: 'date_scheduled',
                        label: 'Job Date',
                        formatter: (val) => this.$moment(val).format('DD/MM/YYYY')
                    },
                    { key: '_actions', label: ' ' }
                ]
            }
        },
        async mounted() {
            await this.loadReports(this.resultPageSize, this.resultPageNumber)
        },
        methods: {
            nextPage() {
                this.loadReports(this.resultPageSize, this.pageNumber + 1)
            },
            previousPage() {
                this.loadReports(this.resultPageSize, this.pageNumber - 1)
            },
            async searchReports() {
                await this.loadReports(this.resultPageSize, 1, this.searchTerm)
            },
            async loadReports(pageSize, pageNumber, searchTerm) {
                this.viewState = 'Busy'
                try {
                    if (searchTerm) {
                        this.isSearchResult = true
                        this.searchTermWas = searchTerm
                        this.reports = await ReportService.getReports(searchTerm)
                    }
                    else {
                        let resultsPage = await ReportService.getReportsPaged(pageSize, pageNumber, searchTerm)

                        this.pageNumber = resultsPage.page_number
                        this.totalPages = resultsPage.total_pages
                        this.totalResults = resultsPage.total_results
                        this.pageSize = resultsPage.page_size
                        this.reports = resultsPage.results
                        
                        this.isSearchResult = false
                        this.searchTermWas = null
                    }

                    this.viewState = 'Idle'
                } catch (err) {
                    console.error('Error loading reports', err)
                    this.viewState = 'Error'
                    this.error = err
                }
            },
            formatAddress(property) {
                let addr1 = property.address_1 ? `${property.address_1}, ` : ''
                let addr2 = property.address_2 ? `${property.address_2}, ` : ''
                let addr3 = property.address_3 ? `${property.address_3}, ` : ''
                let city = property.city ? `${property.city}, ` : ''

                return `${addr1}${addr2}${addr3}${city}${property.postcode}`
            }
        }
    }
</script>